import wbsBookingsApi from '../apis/wbsBookingsApi';

const deleteActivityAvatarsService = async (
  activityId: string,
): Promise<void> => {
  await wbsBookingsApi.delete(`/avatars/activities/${activityId}`);
};

export default deleteActivityAvatarsService;
